'use client';

import "./globals.css";
import React, { useEffect } from "react";
import { Figtree } from "next/font/google";
import Navbar from "@/components/Navbar/Navbar";
import Footer from "@/components/Footer/footer";
import QuickContactSnippet from "@/components/ContactUs/QuickContactSnippet";
import CookieBanner from "@/components/CookieBanner/CookieBanner";
import initGlobalScrollAnimation from "@/components/Animation/ScrollAnimation";

const figtree = Figtree({
  subsets: ["latin"],
  weight: ["300"],
  variable: "--font-figtree",
  display: "swap",
});

export default function Layout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Initialize the global scroll animation once
    const cleanup = initGlobalScrollAnimation({
      selector: "section:not([data-no-animation]), div:not([data-no-animation])",
      threshold: 0.15,
      delayStep: 170, // adjust this for slower or faster stagger
      baseDelay: 100, // delay before the first element animates
    });

    return cleanup;
  }, []);

  return (
    <html lang="en" className={figtree.variable}>
      <body className="flex flex-col min-h-screen bg-HomePage text-text-primary antialiased overflow-x-hidden">
        <Navbar />
        <main className="flex-grow pt-24">{children}</main>
        <QuickContactSnippet />
        <Footer />
        
        {/* Cookie Consent Banner - Fixed at bottom */}
        <CookieBanner />
      </body>
    </html>
  );
}